export type LegalDocSlug =
  | 'terms'
  | 'privacy'
  | 'acceptable-use'
  | 'refund-cancellation'
  | 'cookie'
  | 'coppa'
  | 'sla'
  | 'safety-ai-disclaimer';

export interface LegalDocMeta {
  slug: LegalDocSlug;
  title: string;
}

export const LEGAL_DOCS: readonly LegalDocMeta[] = [
  { slug: 'terms', title: 'Terms of Service' },
  { slug: 'privacy', title: 'Privacy Policy' },
  { slug: 'acceptable-use', title: 'Acceptable Use Policy' },
  {
    slug: 'refund-cancellation',
    title: 'Refund & Cancellation Policy',
  },
  { slug: 'cookie', title: 'Cookie Policy' },
  { slug: 'coppa', title: 'COPPA Compliance Policy' },
  { slug: 'sla', title: 'Service Level Agreement (SLA)' },
  { slug: 'safety-ai-disclaimer', title: 'Safety & AI Disclaimer' },
] as const;

export function getLegalDoc(slug: string | undefined): LegalDocMeta | undefined {
  if (!slug) return undefined;
  return (LEGAL_DOCS as readonly LegalDocMeta[]).find((d) => d.slug === slug);
}

